import React from 'react';
import PropTypes from 'prop-types';
import DataPopover from 'components/DataPopover';
import Icon from 'components/Icon';

function ActionIcon({ tooltipMessage, ...rest }) {
  return (
    <DataPopover tooltipMessage={tooltipMessage}>
      <Icon {...rest} />
    </DataPopover>
  );
}

ActionIcon.propTypes = {
  tooltipMessage: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};

export default ActionIcon;



// WEBPACK FOOTER //
// ./src/components/ActionIcon/index.js